import { render, staticRenderFns } from "./FaturamentoItemsTable.vue?vue&type=template&id=9dd6010c&scoped=true"
import script from "./FaturamentoItemsTable.vue?vue&type=script&lang=js"
export * from "./FaturamentoItemsTable.vue?vue&type=script&lang=js"
import style0 from "./FaturamentoItemsTable.vue?vue&type=style&index=0&id=9dd6010c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd6010c",
  null
  
)

export default component.exports